import { Options } from "../../../common/types/requestOptions";
import { query } from "../../../app/query";
import {
  ChangeRecruitmentArea,
  CreateRecruitmentArea,
  RecruitmentArea,
  RecruitmentAreaById,
  RecruitmentAreaChanged,
  RecruitmentAreaCreated,
  RecruitmentAreaDetails,
  RecruitmentAreaRemoved,
  RemoveRecruitmentArea,
} from "./types";
import { EventPayload } from "../../../common/types/Event";
import { command } from "../../../app/command";

export const recruitmentAreas = (
  filters: { expertId?: string },
  options: Options = {},
): Promise<RecruitmentArea[]> =>
  query<{}, RecruitmentArea[]>(
    "/projections/qry/recruitmentAreas",
    { ...filters },
    options,
  );

export const recruitmentAreaById = (
  filters: RecruitmentAreaById,
  options: Options = {},
): Promise<RecruitmentAreaDetails> =>
  query<RecruitmentAreaById, RecruitmentAreaDetails>(
    "/projections/qry/recruitmentAreaById",
    filters,
    options,
  );

export const createRecruitmentArea = (
  body: CreateRecruitmentArea,
  options: Options = {},
): Promise<EventPayload<RecruitmentAreaCreated>[]> =>
  command<CreateRecruitmentArea, RecruitmentAreaCreated>(
    "/recruitment/cmd/createRecruitmentArea",
    body,
    options,
  );

export const changeRecruitmentArea = (
  body: ChangeRecruitmentArea,
  options: Options = {},
): Promise<EventPayload<RecruitmentAreaChanged>[]> =>
  command<CreateRecruitmentArea, RecruitmentAreaChanged>(
    "/recruitment/cmd/changeRecruitmentArea",
    body,
    options,
  );

export const removeRecruitmentAreaCommand = (
  body: RemoveRecruitmentArea,
  options: Options = {},
): Promise<EventPayload<RecruitmentAreaRemoved>[]> =>
  command<RemoveRecruitmentArea, RecruitmentAreaRemoved>(
    "/recruitment/cmd/removeRecruitmentArea",
    body,
    options,
  );
